import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './App.css';
import { msalConfig } from './authConfig';
import { AuthProvider } from './components/AuthProvider';
import { VendorAuthProvider } from './components/VendorAuthProvider';
import ProtectedRoute from './components/ProtectedRoute';
import VendorProtectedRoute from './components/VendorProtectedRoute';
import VendorRegistrationForm from './components/VendorRegistrationForm';
import VendorDashboardView from './components/VendorDashboard';
import VendorDetail from './components/VendorDetail';
import VendorLoginPage from './components/VendorLoginPage';
import VendorRegistrationStep1 from './components/VendorRegistrationStep1';
import LoginPage from './components/LoginPage';
import NotFoundPage from './components/NotFoundPage';
import StaffLayout from './components/staff/StaffLayout';
import StaffOverview from './components/staff/StaffOverview';
import VendorListPage from './components/staff/VendorListPage';
import UserManagementPage from './components/staff/UserManagementPage';
import EmailNotificationPage from './components/staff/EmailNotificationPage';
import AuditLogPage from './components/staff/AuditLogPage';
import ReportsPage from './components/staff/ReportsPage';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL instance
msalInstance.initialize().then(() => {
  console.log('MSAL initialized successfully');
  console.log('Redirect URI:', msalConfig.auth.redirectUri);
}).catch((error) => {
  console.error('MSAL initialization error:', error);
});

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <VendorAuthProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Root redirect */}
                <Route path="/" element={<Navigate to="/vendor/register" replace />} />
                
                {/* Staff Routes (Microsoft Auth) */}
                <Route path="/staff/login" element={<LoginPage />} />
                <Route
                  path="/staff"
                  element={
                    <ProtectedRoute>
                      <StaffLayout />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<Navigate to="/staff/dashboard" replace />} />
                  <Route path="dashboard" element={<StaffOverview />} />
                  <Route path="dashboard/vendors" element={<VendorListPage />} />
                  <Route path="dashboard/users" element={<UserManagementPage />} />
                  <Route path="dashboard/notifications" element={<EmailNotificationPage />} />
                  <Route path="dashboard/audit-log" element={<AuditLogPage />} />
                  <Route path="dashboard/reports" element={<ReportsPage />} />
                  <Route path="vendor/:id" element={<VendorDetail />} />
                </Route>
                
                {/* Vendor Routes (Firebase Auth) */}
                <Route path="/vendor/login" element={<VendorLoginPage />} />
                <Route path="/vendor/register" element={<VendorRegistrationStep1 />} />
                
                <Route 
                  path="/vendor/dashboard" 
                  element={
                    <VendorProtectedRoute>
                      <VendorDashboardView />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/profile" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="profile" />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/categories" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="categories" />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/banking" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="banking" />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/documents-registration" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="documents-registration" />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/documents-compliance" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="documents-compliance" />
                    </VendorProtectedRoute>
                  } 
                />
                <Route 
                  path="/vendor/dashboard/contact" 
                  element={
                    <VendorProtectedRoute>
                      <VendorRegistrationForm section="contact" />
                    </VendorProtectedRoute>
                  } 
                />
                
                {/* Legacy route for backward compatibility */}
                <Route path="/register" element={<Navigate to="/vendor/register" replace />} />
                <Route path="/dashboard" element={<Navigate to="/vendor/login" replace />} />
                <Route path="/vendor/dashboard/documents" element={<Navigate to="/vendor/dashboard/documents-registration" replace />} />

                {/* 404 catch-all */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </div>
          </Router>
        </VendorAuthProvider>
      </AuthProvider>
    </MsalProvider>
  );
}

export default App;
